module.exports = __webpack_public_path__ + "7c49808c1e1c48b9e1a79748385e73ad.svg";